import { LoyaltyCard } from "./loyalty-card";
import { LoyaltyCardUser } from "./loyalty-card-user";
export class LoyaltyCardUsersSearchResultDto {
  public loyaltycard: LoyaltyCard;
  public users: LoyaltyCardUser[];
}
